'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME = exports.NAME = 'ldiNew';
var validationUrl = exports.validationUrl = process.env.REACT_APP_API_BASE_URI + '/ldi/v1/public/validate-journey';
var actionTypes = exports.actionTypes = {
  SUBMIT_APPLICATION: NAME + '/SUBMIT_APPLICATION',
  PRICE_CHANGE: NAME + '/PRICE_CHANGE'
};
var stages = exports.stages = [{
  link: '/ldi/new/stage1',
  name: "Let's start",
  formId: 'newBusinessStage1',
  review: 'start',
  requiredStrings: [],
  requiredDates: []
}, {
  link: '/ldi/new/stage2',
  name: 'Learner driver details',
  formId: 'newBusinessStage2',
  review: 'learner details',
  requiredStrings: ['claims', 'convictions', 'disallowedOccupations', 'modified', 'modifiedForDisability', 'title', 'forenames', 'surname', 'addressLine1', 'addressLine2', 'addressTownCity', 'addressCounty', 'addressPostcode', 'telephone', 'email', 'employmentStatus', 'occupation', 'industry', 'marketingOptIn'],
  requiredDates: ['dateOfBirth', 'licenceStartDate']
}, {
  link: '/ldi/new/stage3',
  name: 'Car details',
  formId: 'newBusinessStage3',
  review: 'car details',
  requiredStrings: ['regNo', 'abiCode', 'value', 'mainInsurer', 'postcodeKeptOvernight', 'keptOvernight', 'ownerRelation', 'owner', 'ownerEmail', 'vehicleOwnerPermission', 'thirdPartyPermission', 'thirdPartyName', 'thirdPartyEmail', 'advertiser', 'advertiserExtraInfo', 'instructor', 'guid'],
  requiredDates: ['vehiclePurchaseDate']
}, {
  link: '/ldi/new/stage4',
  name: 'Confirmation',
  formId: 'newBusinessStage4',
  review: 'confirmation',
  requiredStrings: ['cover', 'statements', 'policySummary', 'donation'],
  requiredDates: ['coverStartDate']
}];